export default __webpack_public_path__ + "static/media/Skirmisher's Maxim of Entropy.d0f0ebea.jpg";